var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchNoResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5555_71678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1802 25.38C11.9671 25.38 9.80359 24.7237 7.96341 23.4942C6.12322 22.2646 4.68897 20.5169 3.84203 18.4722C2.99508 16.4275 2.77348 14.1776 3.20525 12.0069C3.63702 9.8363 4.70277 7.84243 6.26771 6.27748C7.83266 4.71253 9.82653 3.64679 11.9972 3.21502C14.1678 2.78325 16.4178 3.00485 18.4625 3.85179C20.5072 4.69874 22.2548 6.13299 23.4844 7.97317C24.714 9.81336 25.3702 11.9768 25.3702 14.19C25.3702 17.1578 24.1913 20.004 22.0928 22.1025C19.9942 24.2011 17.148 25.38 14.1802 25.38ZM14.1802 5.00001C12.3626 5.00001 10.5858 5.53899 9.07455 6.5488C7.56326 7.55861 6.38536 8.99389 5.68979 10.6731C4.99422 12.3524 4.81222 14.2002 5.16682 15.9829C5.52142 17.7656 6.39668 19.4031 7.68193 20.6883C8.96717 21.9736 10.6047 22.8488 12.3874 23.2034C14.17 23.558 16.0178 23.376 17.6971 22.6805C19.3764 21.9849 20.8116 20.807 21.8214 19.2957C22.8313 17.7844 23.3702 16.0076 23.3702 14.19C23.3702 11.7527 22.402 9.41515 20.6786 7.69169C18.9551 5.96823 16.6176 5.00001 14.1802 5.00001Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2067 20.5909L20.7925 22.0051L28.4151 29.6277L29.8293 28.2135L22.2067 20.5909Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.904 9.48276L9.48975 10.897L17.473 18.8802L18.8872 17.466L10.904 9.48276Z",
    fill: "#131A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.473 9.48966L9.48975 17.4729L10.904 18.8871L18.8872 10.9039L17.473 9.48966Z",
    fill: "#131A46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5555_71678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.84,
    height: 26.63,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNoResult);
export default __webpack_public_path__ + "static/media/SearchNoResult.2072b153.svg";
export { ForwardRef as ReactComponent };